import React from "react";
import { Button, Grid } from "@mui/material";
import { Backdrop, useMediaQuery, useTheme } from "@mui/material";

const Footernew = () => {
  const theme = useTheme();

  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  return (
    <div className="foot-new">
      <Grid
        container
        sx={{ justifyContent: "center !important", height: "100%", p: 3 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={11}
          xl={10}
          // sx={{ margin: "auto" }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={3}
              xl={3}
              // sx={{ margin: "auto" }}
            >
              <div className="ai-pow mx-width">
                The AI-powered crypto trading platform that simplifies trading
                and maximizes your potential returns.
              </div>
              <div className="display-1 mt-30 gap">
              
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                 
                >
                  <path
                    d="M16.5 3.00002C16.5 3.00002 15.975 4.57502 15 5.55002C16.2 13.05 7.95 18.525 1.5 14.25C3.15 14.325 4.8 13.8 6 12.75C2.25 11.625 0.375 7.20002 2.25 3.75002C3.9 5.70002 6.45 6.82502 9 6.75002C8.325 3.60002 12 1.80002 14.25 3.90002C15.075 3.90002 16.5 3.00002 16.5 3.00002Z"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    
                  />
                </svg>
         
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5 6.75C13.5 5.75544 13.1049 4.80161 12.4017 4.09835C11.6984 3.39509 10.7446 3 9.75 3H6.75C5.75544 3 4.80161 3.39509 4.09835 4.09835C3.39509 4.80161 3 5.75544 3 6.75V12.375C3 13.0712 3.27656 13.7389 3.76884 14.2312C4.26113 14.7234 4.92881 15 5.625 15H10.5"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 7.5C12 6.90326 11.7629 6.33097 11.341 5.90901C10.919 5.48705 10.3467 5.25 9.75 5.25H8.25C7.65326 5.25 7.08097 5.48705 6.65901 5.90901C6.23705 6.33097 6 6.90326 6 7.5V11.1C6 12 6.735 12.75 7.65 12.75H10.35C11.25 12.75 12 12 12 11.1V7.5Z"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.3501 10.5V9.375C13.3501 9.07663 13.4686 8.79048 13.6796 8.5795C13.8906 8.36853 14.1767 8.25 14.4751 8.25H15.0001C15.3979 8.25 15.7795 8.40804 16.0608 8.68934C16.3421 8.97064 16.5001 9.35218 16.5001 9.75V10.5"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.5 10.5V12.75C16.5 13.1478 16.342 13.5294 16.0607 13.8107C15.7794 14.092 15.3978 14.25 15 14.25H14.625C14.4261 14.25 14.2353 14.171 14.0947 14.0303C13.954 13.8897 13.875 13.6989 13.875 13.5V12.375C13.875 12.1761 13.954 11.9853 14.0947 11.8447C14.2353 11.704 14.4261 11.625 14.625 11.625H16.5"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2498 16.5V13.5C11.3542 12.5605 11.0848 11.6176 10.4998 10.875C12.7498 10.875 14.9998 9.375 14.9998 6.75C15.0598 5.8125 14.7973 4.89 14.2498 4.125C14.4598 3.2625 14.4598 2.3625 14.2498 1.5C14.2498 1.5 13.4998 1.5 11.9998 2.625C10.0198 2.25 7.97984 2.25 5.99984 2.625C4.49984 1.5 3.74984 1.5 3.74984 1.5C3.52484 2.3625 3.52484 3.2625 3.74984 4.125C3.20375 4.88691 2.9387 5.81459 2.99984 6.75C2.99984 9.375 5.24984 10.875 7.49984 10.875C7.20734 11.2425 6.98984 11.6625 6.86234 12.1125C6.73484 12.5625 6.69734 13.035 6.74984 13.5V16.5"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.75 13.5C3.3675 15 3 12 1.5 12"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 6C13.1935 6 14.3381 6.47411 15.182 7.31802C16.0259 8.16193 16.5 9.30653 16.5 10.5V15.75H13.5V10.5C13.5 10.1022 13.342 9.72064 13.0607 9.43934C12.7794 9.15804 12.3978 9 12 9C11.6022 9 11.2206 9.15804 10.9393 9.43934C10.658 9.72064 10.5 10.1022 10.5 10.5V15.75H7.5V10.5C7.5 9.30653 7.97411 8.16193 8.81802 7.31802C9.66193 6.47411 10.8065 6 12 6Z"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.5 6.75H1.5V15.75H4.5V6.75Z"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3 4.5C3.82843 4.5 4.5 3.82843 4.5 3C4.5 2.17157 3.82843 1.5 3 1.5C2.17157 1.5 1.5 2.17157 1.5 3C1.5 3.82843 2.17157 4.5 3 4.5Z"
                    stroke="var(--clr-font)"
                    stroke-opacity="0.6"
                    stroke-width="0.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              lg={3}
              xl={3}
              sx={{ margin: lg && "0px 0px" }}
            >
              <div className="fot-hd">Product</div>
              <div className="mt-10 ai-pow">Features</div>
              <div className="mt-10 ai-pow">Pricing</div>
              <div className="mt-10 ai-pow">About</div>
              <div className="mt-10 ai-pow">Roadmap</div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              lg={3}
              xl={3}
              // sx={{ margin: "0px 45px" }}
            >
              <div className="fot-hd">Resources</div>
              <div className="mt-10 ai-pow">Blog</div>
              <div className="mt-10 ai-pow">Documentation</div>
              <div className="mt-10 ai-pow">API Reference</div>
              <div className="mt-10 ai-pow">Support</div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              lg={3}
              xl={2}
              // sx={{ margin: "0px 45px" }}
            >
              <div className="fot-hd">Company</div>
              <div className="mt-10 ai-pow">About Us</div>
              <div className="mt-10 ai-pow">Contact</div>
              <div className="mt-10 ai-pow">Careers</div>
              <div className="mt-10 ai-pow">Terms & Privacy</div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              sx={{ marginTop: lg && "45px", marginBottom: !lg && "45px" }}
            >
              <div className="display-2 mt-30 flex-wrap">
                <div className="ai-pow">
                  © 2025 Dreamster All rights reserved.
                </div>
                <div className="display-1 gap flex-wrap">
                  <div className="ai-pow">Privacy Policy</div>
                  <div className="ai-pow">Terms of Service</div>
                  <div className="ai-pow">Cookie Policy</div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Footernew;
